import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import MovieCategory from "@/pages/category/movie/page";
import TvCategory from "@/pages/category/tv/page";
import Special from "@/pages/special/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import MediaDetail from "@/pages/detail/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/movie", element: <MovieCategory /> },
      { path: "category/tv", element: <TvCategory /> },
      { path: "special", element: <Special /> },
      { path: "news", element: <NewsList /> },
      { path: "news/detail/:id", element: <NewsDetail /> },
      { path: "detail/:id", element: <MediaDetail /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;